/* istanbul ignore file */
import { ProjectToolMessageCallback } from 'domain/projects/shared/projectToolsCreation';
import { AzureGroupsProvisionStepStatus, ExecutionStatus } from './useCreateOnePasswordResponseHandler';

type CreateProjectAzureGroupsResponse = {
  groupsStepStatus?: AzureGroupsProvisionStepStatus;
};

const useCreateAzureGroupsResponseHandler = () => {
  const handleAzureGroupsProvisionStep = (
    groupStatus: AzureGroupsProvisionStepStatus,
    callback: ProjectToolMessageCallback,
  ) => {
    if (groupStatus.status === ExecutionStatus.SUCCESS) {
      callback({ type: 'log', level: 'success', message: `Role Specific Azure Groups have been created!` });
      return true;
    } else {
      let isProblemRelatedToProjectUpdate = true;
      groupStatus.groups?.forEach(group => {
        if (group?.status === ExecutionStatus.FAIL) {
          callback({
            type: 'log',
            level: 'error',
            message: `Failed to create Role Specific Azure Group with key ${group?.key} due to: ${group?.errors?.join(' ')}`,
          });
          isProblemRelatedToProjectUpdate = false;
        }
      });

      if (isProblemRelatedToProjectUpdate) {
        callback({
          type: 'log',
          level: 'error',
          message: `Role Specific Azure Groups have been created, but system cannot update related values for Project Entity. Please contact DaVinci Support.`,
        });
      }
    }
    return false;
  };

  const handleAzureGroupsResponse = (state: CreateProjectAzureGroupsResponse, callback: ProjectToolMessageCallback) => {
    let isPassed = true;

    if (state.groupsStepStatus) {
      isPassed = handleAzureGroupsProvisionStep(state.groupsStepStatus, callback);
    }

    callback({ type: 'status', status: isPassed ? 'passed' : 'failed' });
  };

  return {
    handleAzureGroupsResponse,
  };
};

export default useCreateAzureGroupsResponseHandler;
